import { Button } from "antd-mobile";
import { useHistory } from "react-router";

import { INDEX_ROUTE } from "routes";

const NotFoundPage = () => {
  const history = useHistory();
  return (
    <div className="not-found-page">
      <div className="text-center">
        <p className="text-lg font-bold">
          Page not found
        </p>
        <Button
          color="primary"
          fill="solid"
          size="large"
          className="mt-12"
          onClick={() => history.push(INDEX_ROUTE)}
        >
          Go back
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
